export const BUTTON_VARIABLES = [
  { label: '100', stake: 100 },
  { label: '500', stake: 500 },
  { label: '1K', stake: 1000 },
  { label: '5K', stake: 5000 },
  { label: '10K', stake: 10000 },
  { label: '50K', stake: 50000 },
  { label: '100K', stake: 100000 },
  { label: '500K', stake: 500000 },
  { label: '1000K', stake: 1000000 },
];

export const ONE_CLICK_BETTING_STAKES = [100, 500, 1000, 5000];
